/* ===========================================================================
   Jabree — side-cart upsell ranking.

   Lifted out of assets/jab-tier.js on 2026-08-17. That file only loaded during
   the 4 YEARS sale window, so when the sale ended the drawer silently fell back
   to jab-cart.js's DOM order (the merchant's drag order in the Customizer).
   This runs all the time and has no sale coupling — the only threshold left in
   the store is free U.S. shipping, which it reads from #jab-cart-config so
   there is one source of truth.

   ATTACHES to the cart drawer rather than being folded into assets/jab-cart.js
   (22KB, over the upsert ceiling for a cloud session).

   score = (3*shipFit + 2*affinity + merch/4) * depth      ties -> cheaper first
   Config (merch + pairs) lives in snippets/jab-upsell-rank.liquid.
   =========================================================================== */
(function () {
  'use strict';

  var cfgEl = document.getElementById('jab-upsell-rank-config');
  if (!cfgEl) return;

  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) {
    console.error('[jab-upsell-rank] bad config JSON', e);
    return;
  }
  if (!cfg || !cfg.enabled) return;

  /* Free-shipping threshold, in cents, straight off the cart's own config so it
     can never disagree with the progress bar. Zero outside the US (ship_mode is
     'flat' or 'calc' there and there is no threshold to chase). */
  var SHIP_MIN = 0;
  try {
    var cartCfg = JSON.parse(document.getElementById('jab-cart-config').textContent);
    if (cartCfg && cartCfg.freeShip && cartCfg.freeShip.enabled &&
        cartCfg.intl && cartCfg.intl.mode === 'free') {
      SHIP_MIN = cartCfg.freeShip.threshold || 0;
    }
  } catch (e) {}

  /* Market-aware symbol from layout/theme.liquid; cfg.moneySymbol is the fallback. */
  function moneyParts() {
    return window.jabMoneyParts || { pre: cfg.moneySymbol || '$', post: '' };
  }
  function money(cents) {
    var n = (cents || 0) / 100;
    var p = moneyParts();
    return p.pre + (n % 1 === 0 ? n.toFixed(0) : n.toFixed(2)) + p.post;
  }

  // Mirrors jab-cart.js: a gift-with-purchase line is not money the shopper spent.
  function isGift(item) {
    if (!item.properties) return false;
    return !!(item.properties._gift || item.properties._free_gift);
  }

  /* What counts toward free shipping. original_line_price (pre-discount) is the
     figure Shopify tests a shipping-rate minimum against. */
  function qualifyingSubtotal(cart) {
    var sum = 0;
    (cart.items || []).forEach(function (it) {
      if (isGift(it)) return;
      if (cfg.excludeHandles && cfg.excludeHandles.indexOf(it.handle) !== -1) return;
      sum += (typeof it.original_line_price === 'number')
        ? it.original_line_price
        : (it.price * it.quantity);
    });
    return sum;
  }

  /* How well does adding this item land free shipping?
       1.0  price closes the gap almost exactly
       decays as it overshoots (a $137 jacket to close a $20 gap is a big ask)
       small non-zero when it cannot close the gap alone, so it still beats nothing
     Returns 0 when there is no gap — then affinity and merch priority decide. */
  function shipFit(price, gap) {
    if (!gap || !price) return 0;
    if (price >= gap) return 1 / (1 + ((price / gap) - 1) * 0.6);
    return 0.15 * (price / gap);
  }

  /* Size-run health from data-cover (% of this product's variants still in stock).
     A product down to one size is a bad recommendation however many units are left
     — most shoppers physically cannot buy it, so the card burns a slot and reads
     picked-over. Single-variant products (scarf, glove) are always 100. Live data,
     so a belt that sells down to one waist demotes itself with no config edit. */
  function depth(card) {
    var c = parseInt(card.getAttribute('data-cover'), 10);
    if (isNaN(c)) return 1;
    if (c >= 60) return 1;
    if (c >= 35) return 0.6;
    return 0.25;
  }

  /* Handles worth suggesting given what is already in the cart. */
  function affinitySet(cart) {
    var want = {}, pairs = cfg.pairs || {};
    (cart.items || []).forEach(function (it) {
      var list = pairs[it.handle];
      if (list) list.forEach(function (h) { want[h] = 1; });
    });
    return want;
  }

  function cardHandle(c) { return c.getAttribute('data-handle') || ''; }

  function cardPrice(c) {
    var el = c.querySelector('.jab-up__price');
    if (!el) return 0;
    // Take the LAST money token so a compare-at <del> price is ignored.
    var m = (el.textContent || '').match(/[\d.,]+/g);
    if (!m || !m.length) return 0;
    return Math.round(parseFloat(m[m.length - 1].replace(/,/g, '')) * 100) || 0;
  }

  function paintUpsells(cart) {
    var box = document.querySelector('#jab-cart-root .jab-up');
    var row = box && box.querySelector('.jab-up__row');
    if (!row) return;

    var cards = Array.prototype.slice.call(row.querySelectorAll('.jab-up__card'));
    if (!cards.length) return;

    var subtotal = qualifyingSubtotal(cart);
    /* An EMPTY cart has no gap worth closing. Nobody opens an empty drawer meaning
       to clear $85 in one item, and treating the whole threshold as a "gap" made
       shipFit reward whatever was most expensive — which put thin-size outerwear
       at the top of a cold cart. Zeroing it hands an empty cart to merch x depth,
       i.e. the deep, fully-sized stock we actually want to move. */
    var gap = (subtotal > 0 && SHIP_MIN) ? Math.max(0, SHIP_MIN - subtotal) : 0;

    var want = affinitySet(cart), merch = cfg.merch || {}, inCart = {};
    (cart.items || []).forEach(function (it) { inCart[it.product_id] = 1; });

    cards.forEach(function (c) {
      var h = cardHandle(c);
      c._jrPrice = cardPrice(c);
      c._jrIn    = !!inCart[parseInt(c.getAttribute('data-product-id'), 10)];
      c._jrScore = (3 * shipFit(c._jrPrice, gap)
                 +  2 * (want[h] ? 1 : 0)
                 +  1 * ((merch[h] || 0) / 4)) * depth(c);
    });

    cards.sort(function (a, b) {
      if (a._jrIn !== b._jrIn) return a._jrIn ? 1 : -1;   // already in the cart sinks
      if (b._jrScore !== a._jrScore) return b._jrScore - a._jrScore;
      return a._jrPrice - b._jrPrice;                      // same score, smaller ask
    });
    cards.forEach(function (c) { row.appendChild(c); });

    /* Cap AFTER ranking, not before. jab-cart.js renderUpsells() caps in DOM
       order, so without this the visible set is frozen to the first N cards in
       the merchant's drag order and a 19-product pool can never show items
       9-19 on first open. Applying it here means both land on the same set
       whichever /cart.js fetch resolves last. */
    var max = cfg.upsellMax || 8, shown = 0;
    cards.forEach(function (c) {
      var hide = c._jrIn || shown >= max;
      c.style.display = hide ? 'none' : '';
      if (!hide) shown++;
    });
    box.classList.toggle('is-empty', shown === 0);

    // Badge only the single best closer, so it reads as a recommendation not a sale tag.
    var badged = false;
    cards.forEach(function (c) {
      var old = c.querySelector('.jab-up__unlock');
      if (old) old.remove();
      if (cfg.shipBadge && !badged && gap && !c._jrIn &&
          c.style.display !== 'none' && c._jrPrice >= gap) {
        var b = document.createElement('span');
        b.className = 'jab-up__unlock';
        b.textContent = 'Free shipping';
        c.appendChild(b);
        badged = true;
      }
    });
  }

  var inFlight = false;
  function refresh() {
    if (inFlight) return;
    inFlight = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(paintUpsells)
      .catch(function () {})
      .then(function () { inFlight = false; });
  }

  /* Catch every cart mutation site-wide. jab-cart.js already monkeypatches
     window.fetch for /cart/add; patching again here is additive and safe as long
     as we only observe (never swallow) the response. */
  var _fetch = window.fetch;
  window.fetch = function () {
    var args = arguments;
    var url = '';
    try { url = (typeof args[0] === 'string') ? args[0] : (args[0] && args[0].url) || ''; } catch (e) {}
    var p = _fetch.apply(this, args);
    if (/\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(function () { setTimeout(refresh, 60); }).catch(function () {});
    }
    return p;
  };

  // The drawer is rendered once and re-populated, so re-rank whenever it opens.
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-testid="cart-drawer-trigger"], a[href$="/cart"], .jab-cart__close')) {
      setTimeout(refresh, 120);
    }
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }

  window.JabUpsellRank = { refresh: refresh, config: cfg, shipMin: SHIP_MIN };
})();
